export default {
  // Common
  'payments.achReceiver': 'ACH Receiver',
  'payments.allPayments': 'All Payments',
  'payments.collectPayments': 'Collect Payments',
  'payments.regularPayments': 'Regular Payments',
  'payments.allReceivers': 'All Receivers',
  'payments.approved': 'Payment approved',
  'payments.rejected': 'Payment rejected',
  'payments.companyDiscretionaryData': 'Company Discretionary Data',
  'payments.companyEntryDescription': 'Company Entry Description',
  'payments.companyId': 'ACH Sender ID',
  'payments.created': 'Payment has been created',
  'payments.deleted': 'Payment has been deleted',
  'payments.effectiveEntryDate': 'Effective Entry Date',
  'payments.failed': 'Payment failed',
  'payments.importManager': 'Import Manager',
  'payments.importWire': 'Import Wire',
  'payments.individualEntryState': 'Individual Entry State',
  'payments.individualIdNumber': 'Individual ID Number',
  'payments.initiatePayment': 'Initiate Payment',
  'payments.initiatePayments': 'Initiate Payment(s)',
  'payments.messageToPayee': 'Message To Payee',
  'payments.modifyPaymentDetails': 'Modify Payment Details',
  'payments.noDataMessage': 'No rows selected.',
  'payments.noteNumber': 'Note',
  'payments.noPaymentsFound': 'No Payments Found',
  'payments.noPaymentsToApprove': 'No payments to approve',
  'payments.amount': 'Amount',
  'payments.paymentMaps': 'Payment Maps',
  'payments.fxDebitAmount': 'FX USD Debit Amount',
  'payments.payeeName': 'Payee Name',
  'payments.modalTitle.delete': 'Delete Payment Template',
  'payments.paymentCategory': 'Payment Category',
  'payments.modalTitle.deletetransactions': 'Delete Transaction',
  'payments.pendNo': 'Pend No',
  'payments.modalBody.delete': 'template(s) will be deleted and will be permanently removed.',
  'payments.saved': 'Payment saved',
  'payments.modalBody.deletetransactions':
    'Transaction will be deleted and will be permanently removed.',
  'payments.sender': 'ACH Sender',
  'payments.modalBody.disable': 'template(s) will be disabled.',
  'payments.statusDescription': 'Status Description',
  'payments.datePicker.display': 'Transaction Dates to Display',
  'payments.datePicker.options.today': 'Today + Future Dated',
  'payments.datePicker.options.yesterday': 'Yesterday',
  'payments.datePicker.options.last7Days': 'Last 7 Days + Future Dated',
  'payments.datePicker.options.last30Days': 'Last 30 Days',
  'payments.datePicker.options.thisMonth': 'This Month',
  'payments.datePicker.options.lastMonth': 'Last Month',

  // Utils
  'payments.bulk.approve': 'Payment(s) approved.',
  'payments.wireEntryDateTime': 'Wire Entry Date/Time',
  'payments.wireType': 'Wire Type',
  'payments.bulk.delete': 'Payment(s) deleted.',
  'payments.reason': 'Reason',
  'payments.bulk.error': '<%=count %> Payment(s) cannot be approved',
  'paymentsActions.copyAsPayment': 'Copy as Payment',
  'payments.bulk.reject': 'Payment(s) rejected.',
  'paymentsActions.copyAsTemplate': 'Copy as Template',
  'payments.bulk.warning':
    'Warning: One or more wire transfers may not be processed due to insufficient funds. Please ensure funds are available for processing.',
  'payments.modalTitle.disable': 'Disable Payment Template',
  'payments.bulkActionNotPermitted.approve': 'Some selected payments are not eligible to approve',
  'payments.bulkActionNotPermitted.approve.partialFail':
    'There were some issues approving the following payments',
  'payments.modalTitle.reviewImport': 'Review Import',
  'payments.bulkActionNotPermitted.copyaspayment': 'Could not copy as payment',
  'payments.modalBody.proceed': 'Do you want to proceed?',
  'payments.bulkActionNotPermitted.delete': 'Some selected payments are not eligible to delete',
  'payments.bulkActionNotPermitted.delete.partialFail':
    'There were some issues deleting the following payments',
  'payments.state.error': 'Amount for an active transaction must be greater than $0.00',
  'payments.bulkActionNotPermitted.initiate.partialFail':
    'There were some issues sending the following payments',
  'payments.bulkActionNotPermitted.reject': 'Some selected payments are not eligible to reject',
  'payments.bulkActionNotPermitted.reject.partialFail': 'Payment(s) cannot be rejected',
  'payments.bulkActionNotPermitted.send.partialFail':
    'There were some issues sending the following payments',
  'payments.bulkActionNotPermitted.sendInitiate.partialFail':
    'There were some issues sending the following payments',
  'payments.confirmation.approve.about': 'You are about to approve the following payments',
  'payments.confirmation.approve.reversals.about':
    'You are about to approve the following reversals',
  'payments.confirmation.approve.sameDayACH':
    'Payment eligible for same day ACH. Remove from list and go to individual payment to initiate as same day ACH.',
  'payments.confirmation.approve.updateError': 'The following payment(s) cannot be processed.',
  'payments.confirmation.approve.updateTransactionButton': 'Update New Transaction Date',
  'payments.confirmation.approve.updateTransactionMessage':
    'Some of the selected payments are stale dated. Click on Update New Transaction Date to advance the transaction date to next available and continue with payment approval.',
  'payments.confirmation.delete.about': 'You are about to delete the following payments',
  'payments.confirmation.delete.reversals.about':
    'You are about to delete the following reversals',
  'payments.confirmation.reject.about': 'You are about to reject the following payments',
  'payments.confirmation.reject.reversals.about':
    'You are about to reject the following reversals',
  'payments.confirmation.title.approve': 'Approve Payments',
  'payments.confirmation.title.delete': 'Delete Payments',
  'payments.confirmation.title.reject': 'Reject Payments',
  'payments.confirmation.title.reversals.approve': 'Approve Reversals',
  'payments.confirmation.title.reversals.delete': 'Delete Reversals',
  'payments.confirmation.title.reversals.reject': 'Reject Reversals',
  'payments.error.approve': 'Error! Payment Was Not Approved.',
  'payments.error.delete': 'Error! Payment Was Not Deleted.',
  'payments.error.reject': 'Error! Payment Was Not Rejected.',
  'payments.success.approve': 'Success! Payment Approved.',
  'payments.error.template.approve': 'Error! Template Was Not Approved.',
  'payments.success.delete': 'Success! Payment Deleted.',
  'payments.error.template.delete': 'Error! Template Was Not Deleted.',

  // ACH ACTIONS
  'payments.success.reversals.approve': 'Reversal Approved',
  'payments.error.template.disable': 'Success! Template Was Not Disabled.',
  'payments.success.reversals.delete': 'Reversal Deleted',
  'payments.confirmation.reversal.dateHasBeenChanged.single':
    'Transaction Date has been changed to <%= updatedTransactionDate %> by <%= modifyUser %> on <%= modifyDatetime %>. \nDo you want to proceed with <%= actionType %>?',
  'payments.success.reversals.reject': 'Reversal Rejected',
  'payments.confirmation.reversal.dateHasBeenChanged.multiple':
    'Transaction Dates for Reversals with customer trace number <%= ids %> have been changed. \nDo you want to proceed with <%= actionType %>?',
  'payments.success.reject': 'Success! Payment Rejected.',
  'payments.confirmation.reversal.dateHasBeenChanged.singleInBulk':
    'Transaction Date for Reversal with customer trace number <%= ids %> has been changed to <%= updatedTransactionDate %> by <%= modifyUser %> on <%= modifyDatetime %>. \nDo you want to proceed with <%= actionType %>?',
  'payments.success.template.approve': 'Success! Template Approved.',

  // TAX PAYMENTS
  'payments.endDate': 'End Date',
  'payments.success.template.delete': 'Success! Template Deleted.',
  'payments.success.template.disable': 'Success! Template Disabled.',
  'payments.error.template.enable': 'Success! Template Was Not Enabled.',
  'payments.success.template.reject': 'Success! Template Rejected.',
  'payments.error.template.reject': 'Error! Template Was Not Rejected.',
  'payments.initiateTaxPayment': 'Initiate Tax Payment',
  'payments.success.template.enable': 'Success! Template Enabled.',
  'payments.modifyTaxPayment': 'Modify Tax Payment',
  'payments.nineDigitEIN': '9 Digit EIN',
  'payments.medicareAmount': 'Medicare Amount',
  'payments.nineDigitSSN': '9 Digit SSN',
  'payments.createTaxPayment.success': 'Successfully activated tax payment',
  'payments.paymentDetails': 'Payment Details',
  'payments.PAYMENTS.INVALID_FORMAT': 'Invalid amount',
  'payments.socialSecurityAmount': 'Social Security Amount',
  'payments.PAYMENTS.TRANSACTION_LIMIT_EXCEED': 'Amount exceeds transaction limit',
  'payments.taxAuthority': 'Tax Authority',

  // WIRE LIMIT ERRORS
  'payments.errors.PAYMENTS.EXCEEDS_BANK_TEMPLATE_LIMIT': 'Amount exceeds bank template limit',
  'payments.taxType': 'Tax Type',
  'payments.errors.PAYMENTS.EXCEEDS_DAILY_BANK_TEMPLATE_APPROVAL_LIMIT':
    'Amount exceeds daily bank template approval limit',
  'payments.taxAmountCode': 'Tax Amount Code',
  'payments.taxPeriod': 'Tax Period',

  // API Error Codes
  'payments.errors.PAYMENTS.DELETE_FAILED': 'Delete failed',
  'payments.taxPeriodEndDate': 'Tax Period End Date',
  'payments.wirePayments.addIntermediaryBank': 'Add 2nd Intermediary Bank',
  'payments.errors.PAYMENTS.ALREADY_DELETED': 'Payment already deleted',
  'payments.withholdingAmount': 'Withholding Amount',
  'payments.errors.PAYMENTS.ALREADY_APPROVED': 'Payment already approved',
  'payments.errors.PAYMENTS.EXCEEDS_DAILY_BANK_TEMPLATE_LIMIT':
    'Amount exceeds bank template limit',
  'payments.errors.PAYMENTS.APPROVAL_FAILED': 'Approve failed',
  'payments.errors.PAYMENTS.EXCEEDS_DAILY_TRANSACTION_APPROVAL_LIMIT':
    'Amount exceeds daily transaction approval limit',

  // WIRE PAYMENTS
  'payments.wirePayments.balanceCheckWarning':
    'Warning: insufficient funds, please ensure funds are available for processing',
  'payments.errors.PAYMENTS.EXCEEDS_DAILY_TRANSACTION_LIMIT':
    'Amount exceeds daily transaction total limit',
  'payments.errors.PAYMENTS.EXCEEDS_TRANSACTION_APPROVAL_LIMIT':
    'Amount exceeds transaction approval limit',
  'payments.errors.PAYMENTS.EXCEEDS_TRANSACTION_LIMIT':
    'Amount exceeds transaction approval limit',
  'payments.errors.failedAction': 'Action not completed',
  'payments.tax.amount': 'Tax Amount',
  'payments.tax.amountCode': 'Tax Amount Code',
  'payments.tax.authority': 'Taxpayer Authority',
  'payments.tax.first': 'First',

  // TAX
  'payments.tax.form': 'Tax Form',
  'payments.tax.initApproveInfo': 'Initiation & Approval Information',

  // ADDENDA
  'payments.addenda.createAddenda': 'Create Addenda',
  'payments.tax.mcAmount': 'Medicare Amount',
  'payments.tax.payerId': 'Taxpayer ID',
  'payments.addenda.referenceNumberQualifier': 'Reference Number Qualifier',
  'payments.tax.periodEndDate': 'Tax Period End Date',
  'payments.addenda.referenceIdNumber': 'Reference ID Number',
  'payments.tax.type': 'Tax Type',
  'payments.addenda.invoiceAmount': 'Invoice Amount',
  'payments.tax.second': 'Second',
  'payments.addenda.adjustedAmount': 'Adjusted Amount',
  'payments.tax.ssAmount': 'Social Security Amount',
  'payments.addenda.adjustmentReason': 'Adjustment Reason',
  'payments.addenda.discountAmount': 'Discount Amount',
  'payments.tax.third': 'Third',
  'payments.addenda.invoiceAmountPaid': 'Invoice Amount Paid',
  'payments.addenda.miscChildSupport': 'Misc - Child Support',
  'payments.tax.whAmount': 'Withholding Amount',
  'payments.addenda.caseIdentifier': 'Case Identifier',
  'payments.addenda.absentParentName': 'Absent Parent Name',
  'payments.addenda.remittanceAdviceAddenda': 'Remittance Advice Addenda',
  'payments.addenda.employmentTerm': 'Employment Term',
  'payments.addenda.referenceNumber': 'Reference Number',
  'payments.addenda.fipsCode': 'FIPS Code',
  'payments.addenda.noteSpecialInstruction': 'Note/Special Instruction',
  'payments.addenda.medicalSupport': 'Medical Support',
  'payments.addenda.paymentData': 'Payment Data',
  'payments.addenda.noteReferenceCode': 'Note Reference Code',
  'payments.addenda.referenceIdentification': 'Reference Identification',
  'payments.addenda.trace': 'Trace',
  'payments.addenda.traceCode': 'Trace Code',

  // WIRE IMPORT
  'payments.wireImport': 'Wire Import',
  'payments.wireImport.amount': 'Amount',
  'payments.wireImport.failedRecords': 'Failed Records',
  'payments.wireImport.fileName': 'File Name',
  'payments.wireImport.fileTotal': 'File Total',
  'payments.wireImport.goodRecords': 'Good Records',
  'payments.wireImport.importDate': 'Import Date',
  'payments.wireImport.importIdReference': 'Import ID Reference',

  // MANAGE IMPORT MAPS
  'payments.manageImportMaps.heading': 'Manage Payment Map',
  'payments.wireImport.importTotal': 'Import Total',
  'payments.wireImport.possibleDuplicates': 'Possible Duplicates',
  'payments.manageImportMaps.addMap': 'Add Map',
  'payments.wireImport.recordsInFile': 'Records in File',
  'payments.manageImportMaps.addManageImportMaps': 'Add/Manage Import Maps',
  'payments.wireImport.totalPayments': 'Total Payments',
  'payments.manageImportMaps.mapName': 'Map Name',
  'payments.wireImport.importedBy': 'Imported By',
  'payments.manageImportMaps.mapType': 'Map Type',
  'payments.wireImport.message': 'Message',
  'payments.manageImportMaps.mapCode': 'Map Code',
  'payments.manageImportMaps.createdBy': 'Created By',
  'payments.wireImport.status': 'Status',
  'payments.manageImportMaps.lastUsedBy': 'Last Used By',
  'payments.wireImport.paymentType': 'Payment Type',
  'payments.manageImportMaps.custId': 'Customer ID',
  'payments.manageImportMaps.delimiter': 'Delimiter',
  'payments.wireImport.mapType': 'Map Type',
  'payments.manageImportMaps.createImportMap': 'Create an Import Map',
  'payments.manageImportMaps.endOfRecordMethod': 'End of Record Method',
  'payments.manageImportMaps.subHeading': 'Import Maps',
  'payments.manageImportMaps.fileType': 'File Type',
  'payments.manageImportMaps.lastUsedDate': 'Last Used Date',
  'payments.manageImportMaps.name': 'Name',
  'payments.manageImportMaps.lbId': 'Lb Id',
  'payments.manageImportMaps.paymentType': 'Payment Type',
  'payments.manageImportMaps.delete.content': 'Are you sure you want to delete <%=mapName %>?',
  'payments.manageImportMaps.type': 'Type',
  'payments.manageImportMaps.delete.confirm': 'This action cannot be undone',

  // PAYMENT ERROR CODES
  'PAYMENTS.INVALID_TRANSACTION_DATE': 'The transaction date selected is invalid.',
  'payments.manageImportMaps.mtMapId': 'Mt Map Id',
  'payments.manageImportMaps.wireType': 'Wire Type',
  'PAYMENTS.INVALID_FORMAT': 'Invalid amount',
  'payments.manageImportMaps.product': 'product',
  'PAYMENTS.EXCEEDS_BANK_TEMPLATE_LIMIT': 'Amount exceeds bank template limit',
  'payments.manageImportMaps.skipFirstRecord': 'Skip Header record(s)',
  'PAYMENTS.EXCEEDS_DAILY_BANK_TEMPLATE_APPROVAL_LIMIT':
    'Amount exceeds daily bank template approval limit',
  'payments.manageImportMaps.skipHeaderRecord': 'Skip Header Record',
  'PAYMENTS.EXCEEDS_DAILY_BANK_TEMPLATE_LIMIT': 'Amount exceeds bank template limit',
  'payments.manageImportMaps.stripQuotes': 'Strip Quotes',
  'PAYMENTS.DELETE_FAILED': 'Delete failed',
  'payments.manageImportMaps.templateType': 'Template Type',
  'PAYMENTS.ALREADY_DELETED': 'Payment already deleted',
  'payments.manageImportMaps.delete.warning': 'Delete Import Map',
  'PAYMENTS.ALREADY_APPROVED': 'Payment already approved',
  'payments.manageImportMaps.delete.failed': 'Import map %map has failed to delete',
  'PAYMENTS.APPROVAL_FAILED': 'Approve failed',
  'PAYMENTS.EXCEEDS_DAILY_TRANSACTION_APPROVAL_LIMIT':
    'Amount exceeds daily transaction approval limit',
  'payments.manageImportMaps.delete.succeeded': 'Import map %map has been deleted',
  'PAYMENTS.EXCEEDS_DAILY_TRANSACTION_LIMIT': 'Amount exceeds daily transaction total limit',
  'PAYMENTS.TRANSACTION_LIMIT_EXCEED': 'Amount exceeds transaction limit',
  'PAYMENTS.EXCEEDS_DYNAMIC_APPROVAL_LIMIT':
    'Cannot submit wire with transaction amount greater than available approval limit.',
  'PAYMENTS.EXCEEDS_TRANSACTION_APPROVAL_LIMIT': 'Amount exceeds transaction approval limit',
  'PAYMENTS.EXCEEDS_TRANSACTION_LIMIT': 'Amount exceeds transaction approval limit',

  // PAYMENT VIEWS
  'payments.filter.containsACH': 'Contains ACH',
  'payments.filter.containsLoanDraw': 'Contains Loan Draw',
  'payments.filter.containsLoanPayment': 'Contains Loan Payment',
  'payments.filter.containsWire': 'Contains Wire',
  'payments.filter.requiresApproval': 'Requires My Approval',
  'payments.filter.requiresApproval.reversal': 'Requires my approval Reversal',
  'payments.filter.staleDated': 'Stale Dated',
  'payments.view.ach': 'ACH Payments',
  'payments.view.loanPayments': 'Loan Payments/Draws',
  'payments.view.requiresApproval': 'Requires My Approval',
  'payments.view.staleDated': 'Stale Dated',
  'payments.view.wire': 'Wire Payments',
  'payments.linkGroups.ach': 'ACH',
  'payments.linkGroups.wire': 'Wire',
  'payments.linkGroups.loan': 'Loan',
  'payments.linkGroups.tax': 'Tax',

  // Payment Types
  'payments.paymentType.DOMESTIC_WIRE': 'Domestic Wire',
  'payments.paymentType.INTERNATIONAL_WIRE': 'International Wire',
  'payments.paymentType.CORPORATE_PAYMENTS': 'Corporate Payments',
  'payments.paymentType.CORPORATE_COLLECTIONS': 'Corporate Collections',
  'payments.paymentType.CORPORATE_PAYMENTS_COLLECTIONS': 'Corporate Payments & Collections',
  'payments.paymentType.EMPLOYEE_PAYMENTS': 'Employee Payments',
  'payments.paymentType.INTERNATIONAL_ACH_PAYMENTS': 'International ACH Payments',
  'payments.paymentType.INTERNATIONAL_ACH_COLLECTIONS': 'International ACH Collections',
  'payments.paymentType.CONSUMER_PAYMENTS': 'Consumer Payments',
  'payments.paymentType.CONSUMER_COLLECTIONS': 'Consumer Collections',
  'payments.paymentType.CONSUMER_PAYMENTS_COLLECTIONS': 'Consumer Payments & Collections',
  'payments.paymentType.REPRESENTED_CHECK': 'Represented Check',
  'payments.paymentType.TELEPHONE_INITIATED_COLLECTIONS': 'Telephone Initiated Collections',
  'payments.paymentType.INTERNET_INITIATED_COLLECTIONS': 'Internet Initiated Collections',
  'payments.paymentType.LOAN_PAYMENT': 'Loan Payment',
  'payments.paymentType.LOAN_DRAW': 'Loan Draw',
  'payments.paymentType.TAX_PAYMENT': 'Tax Payment',

  // Payment Status
  'payments.paymentStatus.ERROR': 'Error',
  'payments.paymentStatus.DELETED': 'Deleted',
  'payments.paymentStatus.PROCESSED': 'Processed',
  'payments.paymentStatus.PROCESSED_REVERSAL': 'Processed Reversal',
  'payments.paymentStatus.READY_TO_PROCESS': 'Ready to process',
  'payments.paymentStatus.READY_TO_PROCESS_REVERSAL': 'Ready to process reversal',
  'payments.paymentStatus.REJECTED_BY_APPROVER': 'Rejected by approver',
  'payments.paymentStatus.REJECTED_BY_APPROVER_REVERSAL': 'Rejected by approver reversal',
  'payments.paymentStatus.REQUIRES_MY_APPROVAL': 'Requires my approval',
  'payments.paymentStatus.REQUIRES_MY_APPROVAL_REVERSAL': 'Requires my approval reversal',
  'payments.paymentStatus.REQUIRES_OTHERS_APPROVAL': "Requires other's approval",
  'payments.paymentStatus.REQUIRES_OTHERS_APPROVAL_REVERSAL': "Requires other's approval reversal",
  'payments.paymentStatus.STALE_DATED': 'Stale dated',
  'payments.paymentStatus.STALE_DATED_REVERSAL': 'Stale dated reversal',
  'payments.paymentStatus.UPDATED': 'Updated',
  'payments.paymentStatus.UPDATED_VIA_IMPORT': 'Updated via Import',

  // Loan payments
  'payments.loan.noteRequired': 'Note is required',
  'payments.loan.noNotesAvailable': 'There are no Notes available for <%=paymentType %>'
};
